export const CONFIRM_MESSAGE = '変更を送信してよろしいですか？（再審査が完了するまで、プロジェクトへ応募できなくなります）';
export const CONFIRM_MESSAGE_IDENTIFICATION_NEEDED = (step: string) => `${step}を変更してよろしいですか？（審査と本人確認が完了するまで、プロジェクトへ応募できなくなります）`;
